var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHomeNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0451 3L3.01224 11.2429C2.98419 11.2758 3.00743 11.3271 3.05072 11.3271H5.75613V19H9.1261V14.2657H12.9633V19H16.3341V11.3271H19.0395C19.0828 11.3271 19.106 11.2758 19.0772 11.2429L11.0451 3Z",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HomeNew.fb6e1116.svg";
export { ForwardRef as ReactComponent };